<div class="settings-container">
  <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs">
    <li [ngbNavItem]="1">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::Redaction' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-redaction-settings></ca-redaction-settings>
      </ng-template>
    </li>
    <li [ngbNavItem]="2">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::VoiceMorphing.Settings.Title' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-voice-morphing-settings></ca-voice-morphing-settings>
      </ng-template>
    </li>
    <li *ngIf="isSuperAdminUser" [ngbNavItem]="3">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::AutoDeletionTitle' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-auto-deletion-settings></ca-auto-deletion-settings>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav"></div>
</div>
